import {
  Swiper,
  Navigation,
  Autoplay,
  // Scrollbar,
} from 'swiper';

Swiper.use(Navigation);
Swiper.use(Autoplay);
// Swiper.use(Scrollbar);

let klantenSwiper,
  recensiesSwiper,
  pageheaderHomeSwiper,
  featuredProductsSwiper;

$(window).on('load', function () {
  if ($('.klanten-swiper').length) {
    klantenSwiper = new Swiper('.klanten-swiper', {
      spaceBetween: 30,
      slidesPerView: 5,
      loop: true,
      breakpoints: {
        993: {
          slidesPerView: 5,
        },
        0: {
          slidesPerView: 2.5,
        },
      },
      navigation: {
        prevEl: '.klanten-swiper__controls--prev',
        nextEl: '.klanten-swiper__controls--next',
      },
      autoplay: {
        delay: 5000,
      },
    });
  }
  if ($('.recensies__swiper').length) {
    recensiesSwiper = new Swiper('.recensies__swiper', {
      slidesPerView: 1,
      breakpoints: {
        768: {
          spaceBetween: 60,
        },
        0: {
          spaceBetween: 30,
        },
      },
      navigation: {
        prevEl: '.recensies__swiper__controls--prev',
        nextEl: '.recensies__swiper__controls--next',
      },
      // autoplay: {
      //     delay: 7500,
      // },
    });
  }
  if ($('.product-related-swiper').length) {
    new Swiper('.product-related-swiper', {
      // slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        768: {
          // spaceBetween: 60,
          slidesPerView: 3,
        },
        0: {
          // spaceBetween: 30,
          slidesPerView: 1,
        },
      },
      navigation: {
        prevEl: '.product-related-swiper__controls--prev',
        nextEl: '.product-related-swiper__controls--next',
      },
    });
  }
  if ($('.product-sold-swiper').length) {
    new Swiper('.product-sold-swiper', {
      // slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        768: {
          // spaceBetween: 60,
          slidesPerView: 3,
        },
        0: {
          // spaceBetween: 30,
          slidesPerView: 1.25,
        },
      },
      navigation: {
        prevEl: '.product-sold-swiper__controls--prev',
        nextEl: '.product-sold-swiper__controls--next',
      },
    });
  }
  if ($('.page-header--home__swiper').length) {
    pageheaderHomeSwiper = new Swiper('.page-header--home__swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 600,
      // loop: true,
      autoplay: {
        delay: 5000,
      },
    });
  }
  if ($('.featured-products-swiper').length) {
    featuredProductsSwiper = new Swiper('.featured-products-swiper', {
      spaceBetween: 30,
      slidesPerView: 1.1,
      breakpoints: {
        1200: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 1.5,
        },
      },
      navigation: {
        prevEl: '.featured-products-swiper__controls--prev',
        nextEl: '.featured-products-swiper__controls--next',
      },
      autoHeight: true,
    });
  }
});

$(window).on('resize', function () {
  if (klantenSwiper) {
    klantenSwiper.update();
  }
  if (recensiesSwiper) {
    recensiesSwiper.update();
  }
  if (pageheaderHomeSwiper) {
    recensiesSwiper.update();
  }
  if (featuredProductsSwiper) {
    featuredProductsSwiper.update();
  }
});
